<template>
  <div v-if="companyView" class="company p-0">
    <div class="company-card">
      <lightGallery
        ref="lg"
        :disable-scroll="true"
        :images="gallery"
        :index="galleryIndex"
        @close="galleryIndex = null"
      >
      </lightGallery>
      <div id="gallery" class="company-card__gallery">
        <div v-if="gallery.length > 0" class="gallery d-block">
          <div :data-src="gallery[0]" class="first-image">
            <img
              :alt="company.title"
              :data-src="gallery[0]"
              :src="gallery[0]"
              class="gallery-item"
            />
          </div>

          <div class="company-card__gallery__meta">
            <div class="company-card__gallery__meta__title mb-1">
              <h2>
                {{ company.title }}
              </h2>
            </div>
            <div class="company-card__gallery__meta__category mb-2">
              <h3>
                {{ categoryTitle }}
              </h3>
            </div>
            <div class="rate-wrap">
              <div class="rate">
                <rate
                  :rating="rating"
                  active-color="#fff"
                  inactive-color="#ffffff4a"
                />
              </div>
              <span>
                {{ $tc("catalog.reviews_count", company.reviews_count || 0) }}
              </span>
            </div>
          </div>
        </div>
        <div v-if="thumbnails" class="thumbnails mb-0">
          <div
            v-for="(image, index) in thumbnails"
            :class="{
              'more-text_thumbnail':
                index + 1 === thumbnails.length && gallery.length > 6,
            }"
            :data-src="image"
            class="d-inline-flex position-relative gallery-item"
          >
            <img
              :alt="company.title"
              :data-src="gallery[0]"
              :src="image"
              class="thumbnails__item"
            />

            <div
              v-if="index + 1 === thumbnails.length && gallery.length > 6"
              class="thumbnails__more-text"
            >
              {{ gallery.length - thumbnails.length }} {{ $t("photos") }}
            </div>
          </div>
        </div>
      </div>
      <div class="company-card__in p-3 pt-4">
        <div class="company-card__info">
          <div class="company_info">
            <div
              v-if="company.phones && company.phones.length > 0"
              class="address-block d-flex align-items-center"
            >
              <span class="icon-telephone"></span>
              <div
                id="company-phones"
                class="d-flex align-items-center flex-wrap"
              >
                <a v-for="phone in company.phones" :href="'tel:' + phone">
                  {{ phone }}
                </a>
                <span>
                  <a
                    v-if="!isPhoneShown"
                    class="show-phone"
                    href="#"
                    @click.prevent="showPhone(company.id)"
                  >
                    {{ $t("Show") }}
                  </a>
                </span>
              </div>
            </div>

            <div
              v-if="company.location && company.location.address"
              class="address-block d-flex"
            >
              <span class="icon-Map_pointer"></span>
              <div>{{ company.location.address }}</div>
            </div>

            <div
              v-if="company.website"
              class="address-block d-flex align-items-center"
            >
              <span class="icon-link"></span>
              <a :href="company.website" rel="nofollow, noindex" target="_blank">
                {{ company.website }}
              </a>
            </div>

            <div v-if="company.payment_method" class="address-block d-flex">
              <div class="payment_method"></div>
              {{ paymentMethod }}
            </div>

            <div v-if="company.delivery" class="address-block">
              <span class="icon-delivery"></span>
              {{ $t("Delivery") }}
              <div class="green">
                <span class="icon-validate"></span>
                +€25
              </div>
            </div>
          </div>
        </div>
        <div class="company-card__description mb-3">
          {{ description }}
        </div>
        <div class="shop__left-btn mt-0 mb-4">
          <a
            class="reg-btn green-btn"
            data-target="#company-contact-modal"
            data-toggle="modal"
            href="#"
            >{{ $t("Contact Owner") }}</a
          >
        </div>

        <div v-if="company.open_hours !== undefined" class="shedule">
          <div class="shedule__title">
            <span class="icon-Time"></span>
            {{ $t("Opening Hours") }}
          </div>
          <ul>
            <li v-for="(open_time, index) in company.open_hours">
              <span class="shedule__left">{{ index }}</span>
              <span class="shedule__right"
                >{{ open_time["from"] }} - {{ open_time["to"] }}</span
              >
            </li>
          </ul>
        </div>

        <div class="company-card__services mt-0 mb-4 p-4">
          <div class="services__title pb-3">
            {{ $t("Our Services") }}
          </div>
          <div class="services__wrap">
            <div
              v-for="(service, index) in services"
              :key="service.id"
              :class="{
                'pb-3': index !== services.length - 1,
                'pb-0': index === services.length - 1,
              }"
              class="services__in"
            >
              <div class="services__content">
                <div class="services__name">{{ service.title }}</div>
                <div class="services__categories">
                  <p class="inline">
                    {{ serviceCategoriesTitle(service.category_id) }}
                  </p>
                </div>
              </div>
              <div v-if="service.price_sale">
                <div class="services__price float-right mr-3">
                  €{{ service.price_sale }}
                </div>
                <div
                  class="services__price inline float-right mr-3 cross"
                  style="color: #9fa1b0"
                >
                  €{{ service.sale }}
                </div>
              </div>
              <div v-else class="services__price inline float-right">
                €{{ service.price }}
              </div>
            </div>
          </div>
        </div>
        <div class="company-card__bottom">
          <actions :company="company" :is_favorite="is_favorite"></actions>
        </div>
      </div>
    </div>
    <div id="company-contact-modal" class="modal fade">
      <div class="modal-dialog">
        <div id="company-contact">
          <contact />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Actions from "./Actions.vue";
import Contact from "./Contact.vue";
import Preloader from "./Preloader.vue";
import Vue from "vue";
import LightGallery from "vue-light-gallery";
import Rate from "../../components/Rate.vue";

Vue.use(LightGallery);

export default {
  name: "Company",
  components: {
    Actions,
    Contact,
    Preloader,
    Rate,
  },
  async beforeRouteEnter(to, from, next) {
    let company = await axios.get("/company/" + to.params.company_id);
    next((vm) => vm.setCompany(company));
  },
  async beforeRouteUpdate(to, from, next) {
    this.loading = true;
    let company = await axios.get("/company/" + to.params.company_id);
    this.setCompany(company);
    next();
  },
  data() {
    return {
      company: {},
      gallery: [],
      thumbs: [],
      galleryIndex: null,
      services: [],
      services_images: {},
      loading: false,
      is_favorite: false,
      isPhoneShown: false,
    };
  },
  computed: {
    categoryTitle() {
      let categoryTitle;
      switch (true) {
        case this.$route.name === "company_found_by_word":
          if (this.company.services === undefined) {
            categoryTitle = "";
            break;
          }
          let service = this.company.services[0];
          if (!service) {
            categoryTitle = "category not found";
            break;
          }
          categoryTitle = this.getCategory(service.category_id[0]).title;
          break;
        default:
          categoryTitle = this.getCategory(this.$route.params.id).title;
      }
      return categoryTitle;
    },
    displayFilter() {
      return this.$store.getters.getDisplayFilter;
    },
    paymentMethod() {
      let a = [];
      this.company.payment_method.forEach((item) => {
        a.push(item.title);
      });
      return a.join(", ");
    },
    thumbnails() {
      let gallery = Object.assign([], this.gallery);
      if (gallery < 2) return false;
      return gallery.splice(1, 7);
    },
    rating() {
      if (typeof this.company.rating !== "undefined")
        return parseInt(this.company.rating);
      return 0;
    },
    description() {
      let company = this.company;
      return company.description;
    },
    companyView() {
      return this.$store.getters.getCompanyView;
    },
  },
  created() {
    this.loading = true;
    window.addEventListener("click", (e) => {
      let targetClasses = e.target.classList;
      if (
        targetClasses.contains("light-gallery__image-container") ||
        targetClasses.contains("light-gallery__modal") ||
        targetClasses.contains("light-gallery__content")
      )
        this.galleryIndex = null;
    });
  },
  mounted() {
    this.$store.dispatch("setRefs", this);
    this.$store.commit("setDisplayFilter", false);
    let filter_btn = document.querySelector(".filter-btn");

    if (window.screen.width > 768) this.showFilterBtn(filter_btn);
    else {
      this.hideFilterBtn(filter_btn);
      this.$store.commit("setCatalogBlocksView", false);
    }

    let sidebar = this.$store.getters.getRef("sidebar");
    if (sidebar !== null && typeof sidebar !== "undefined") {
      if (!sidebar.classList.contains("company-shown"))
        sidebar.classList.add("company-shown");
    }
  },
  methods: {
    setCompany(data) {
      this.company = data.data.company;
      this.gallery = data.data.gallery;
      this.services = data.data.services;
      this.is_favorite = data.data.is_favorite;

      let images = data.data.services_images;
      for (var image_id in data.data.services_images) {
        this.$set(this.services_images, image_id, images[image_id]);
      }

      setTimeout(() => {
        this.loadGallery();
        this.loading = false;
      }, 100);

      let company_title = data.data.company.title,
        category = this.getCategory(this.$route.params.id);

      let metaTitle = "";
      metaTitle += company_title;

      if (category !== undefined) metaTitle += " - " + category.title;

      this.$store.commit("setMetaTitle", metaTitle);
      this.$store.commit("setH1", metaTitle);
      this.$store.commit("triggerDynamicH1Resize");
    },
    loadGallery() {
      let items = $("#gallery .gallery-item");

      items.each((index, element) => {
        $(element).click(() => {
          this.galleryIndex = index;
        });
      });
    },
    getCategory(cat_id) {
      return this.$store.getters.getCategory(cat_id);
    },
    serviceCategoryTitle(category_id) {
      return this.getCategory(category_id).title;
    },
    serviceCategoriesTitle(categories) {
      if (!categories.length) return "";
      let cats = [];
      categories.forEach((item) => {
        cats.push(this.serviceCategoryTitle(item));
      });
      return cats.join(", ");
    },
    serviceImage(service) {
      if (typeof service.image_id === "undefined") return false;
      return this.services_images[service.id];
    },
    hideFilterBtn(filter_btn) {
      filter_btn.style.setProperty("display", "none");
    },
    showFilterBtn(filter_btn) {
      filter_btn.style.removeProperty("display");
    },
    showPhone(id) {
      let vm = this;
      $.ajax({
        url: "/company/" + id + "/getPhones",
        method: "GET",
        headers: {
          "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        success(response) {
          vm.company.phones = response;
          vm.isPhoneShown = true;
        },
      });
    },
  },
};
</script>
